const STATUS_SUCCESS: String = "success";
const STATUS_ERROR: String = "error";

export { STATUS_SUCCESS, STATUS_ERROR };
